(function () {
  'use strict';

  function initialize(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var dataNode = root.querySelector('[data-alg-rv-data]');
    var data;
    try { data = JSON.parse(dataNode.textContent); } catch (error) { return; }

    var sizeChoice = root.querySelector('[data-size-choice]');
    var sizeControl = root.querySelector('[data-size-control]');
    var emptyMessage = root.querySelector('[data-empty-message]');
    var orientationButtons = Array.prototype.slice.call(root.querySelectorAll('[data-orientation-choice]'));
    var roomButtons = Array.prototype.slice.call(root.querySelectorAll('[data-room-choice]'));
    var rooms = Array.prototype.slice.call(root.querySelectorAll('[data-room]'));
    var artworks = Array.prototype.slice.call(root.querySelectorAll('[data-art]'));
    var sizeOutput = root.querySelector('[data-size-output]');
    var supportOutput = root.querySelector('[data-support-output]');
    var stage = root.querySelector('[data-stage]');
    var orientation = 'vertical';
    var formats = [];
    var activeFormat = null;
    var syncingFromProduct = false;
    var productSizeSelect = null;

    function normalizeNumber(value) {
      return Number(String(value).replace(',', '.'));
    }

    function parseDimension(value, variant) {
      var source = String(value || '').trim();
      var match = source.match(/(\d+(?:[.,]\d+)?)\s*(?:x|×)\s*(\d+(?:[.,]\d+)?)/i);
      if (!match) return null;

      var first = normalizeNumber(match[1]);
      var second = normalizeNumber(match[2]);
      if (!(first > 0) || !(second > 0)) return null;

      var dimensionSuffix = source.slice(match.index + match[0].length);
      var usesInches = /^\s*(?:in(?:ch(?:es)?)?|po|["″])/i.test(dimensionSuffix) && !/^\s*cm/i.test(dimensionSuffix);
      var unit = usesInches ? 'in' : 'cm';
      var centimeterFactor = usesInches ? 2.54 : 1;
      var beforeDimensions = source.slice(0, match.index).trim();
      var support = (beforeDimensions.split(/\s+/)[0] || '').replace(/[-–—:]+$/, '');
      if (/^toile$/i.test(support)) support = data.strings.canvas;

      return {
        key: variant.id + ':' + source,
        variantId: String(variant.id),
        available: variant.available,
        image: variant.image || data.fallbackImage,
        optionValue: source,
        productValue: variant.productValue || source,
        support: support,
        first: first,
        second: second,
        shortCm: Math.min(first, second) * centimeterFactor,
        longCm: Math.max(first, second) * centimeterFactor,
        unit: unit
      };
    }

    function localizedNumber(value) {
      var locale = root.dataset.marketLocale || document.documentElement.lang || 'fr';
      try {
        return new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(value);
      } catch (error) {
        return String(value).replace('.', ',');
      }
    }

    function measurementLabel(format, horizontal) {
      var width = horizontal ? format.second : format.first;
      var height = horizontal ? format.first : format.second;
      return localizedNumber(width) + ' × ' + localizedNumber(height) + ' ' + format.unit;
    }

    function optionLabel(format) {
      return (format.support ? format.support + ' — ' : '') + measurementLabel(format, false);
    }

    function formatTier(format) {
      if (format.longCm <= 32) return 'very-small';
      if (format.longCm <= 46) return 'small';
      if (format.longCm >= 135 || format.shortCm >= 95) return 'extra-large';
      if (format.longCm >= 95 || format.shortCm >= 68) return 'large';
      return 'standard';
    }

    function setArtworkImage(url) {
      if (!url) return;
      artworks.forEach(function (artwork) {
        var image = artwork.querySelector('[data-art-image]');
        if (!image) {
          artwork.innerHTML = '';
          image = document.createElement('img');
          image.setAttribute('data-art-image', '');
          image.alt = '';
          image.loading = 'lazy';
          artwork.appendChild(image);
        }
        if (image.src !== url) image.src = url;
      });
    }

    function loadActiveRoomPhoto() {
      var currentRoom = rooms.find(function (room) { return !room.hidden; });
      if (!currentRoom) return;
      var photo = currentRoom.querySelector('.alg-rv__photo--standard');
      if (!photo || photo.complete) return;
      photo.loading = 'eager';
      photo.src = photo.getAttribute('src');
    }

    function updatePreview() {
      if (!activeFormat || !stage) return;

      var horizontal = orientation === 'horizontal';
      var widthCm = horizontal ? activeFormat.longCm : activeFormat.shortCm;
      var heightCm = horizontal ? activeFormat.shortCm : activeFormat.longCm;
      var bounds = stage.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;

      // Échelle strictement linéaire : un format de 150 cm est rendu 1,5 fois
      // plus large qu'un format de 100 cm dans une même scène.
      var scale = widthCm / 40;
      var desiredWidth = bounds.width * 0.115 * scale;
      var maxWidth = bounds.width * 0.48;
      var maxWidthFromHeight = bounds.height * 0.72 * (widthCm / heightCm);
      var renderedWidth = Math.max(18, Math.min(desiredWidth, maxWidth, maxWidthFromHeight));

      root.dataset.formatTier = formatTier(activeFormat);
      loadActiveRoomPhoto();
      sizeOutput.textContent = measurementLabel(activeFormat, horizontal);
      supportOutput.textContent = activeFormat.support;
      artworks.forEach(function (artwork) {
        artwork.dataset.orientation = orientation;
        artwork.style.setProperty('--alg-rv-art-width', renderedWidth.toFixed(2) + 'px');
        artwork.style.setProperty('--alg-rv-art-ratio', widthCm + ' / ' + heightCm);
      });
      setArtworkImage(activeFormat.image);
    }

    function findFormatByVariantId(variantId) {
      var id = String(variantId || '');
      return formats.find(function (format) { return format.variantId === id; }) || null;
    }

    function findFormatByProductValue(value) {
      var normalizedValue = String(value || '').trim();
      return formats.find(function (format) { return format.productValue === normalizedValue; }) || null;
    }

    function findProductSizeSelect() {
      var selectors = Array.prototype.slice.call(document.querySelectorAll(
        'select.artem-options__select--native[name^="properties["], select[name^="properties["]'
      ));
      return selectors.find(function (select) {
        var field = select.closest('.artem-options__field');
        var label = field && field.querySelector('label');
        var descriptor = [select.name, label && label.textContent].join(' ');
        var hasDimensions = Array.prototype.some.call(select.options, function (option) {
          var value = option.dataset.displayLabel || option.value;
          return /(\d+(?:[.,]\d+)?)\s*(?:x|×)\s*(\d+(?:[.,]\d+)?)/i.test(value);
        });
        return hasDimensions && /dimension|format|size|taille|größe|afmeting|koko|misura|tamaño|rozmiar|storlek|velikost|μέγεθος/i.test(descriptor);
      }) || null;
    }

    function productPropertyVariants(select) {
      if (!select) return [];
      return Array.prototype.map.call(select.options, function (option, index) {
        var value = String(option.value || '').trim();
        if (!value) return null;
        return {
          id: option.dataset.variantId || 'property-' + index,
          available: !option.disabled,
          image: data.fallbackImage,
          optionValue: option.dataset.displayLabel || value,
          productValue: value
        };
      }).filter(Boolean);
    }

    function selectFormat(format, syncProduct) {
      if (!format) return;
      activeFormat = format;
      sizeChoice.value = format.key;
      updatePreview();
      if (syncProduct) syncProductOption(format);
    }

    function syncProductOption(format) {
      if (syncingFromProduct) return;
      if (productSizeSelect && Array.prototype.some.call(productSizeSelect.options, function (option) {
        return option.value === format.productValue;
      })) {
        syncingFromProduct = true;
        productSizeSelect.value = format.productValue;
        productSizeSelect.dispatchEvent(new Event('input', { bubbles: true }));
        productSizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        window.setTimeout(function () { syncingFromProduct = false; }, 0);
        return;
      }
      var optionInputs = Array.prototype.slice.call(document.querySelectorAll('select[name^="options"], input[name^="options"]'));
      var target = optionInputs.find(function (input) {
        if (input === sizeChoice) return false;
        if (input.tagName === 'SELECT') {
          return Array.prototype.some.call(input.options, function (option) { return option.value === format.optionValue; });
        }
        return input.value === format.optionValue;
      });
      if (!target) return;

      syncingFromProduct = true;
      if (target.tagName === 'SELECT') target.value = format.optionValue;
      else target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
      window.setTimeout(function () { syncingFromProduct = false; }, 0);
    }

    function buildFormats() {
      var seen = Object.create(null);
      productSizeSelect = findProductSizeSelect();
      var formatSources = productPropertyVariants(productSizeSelect);
      if (!formatSources.length) formatSources = data.variants;
      formats = formatSources.map(function (variant) {
        return parseDimension(variant.optionValue, variant);
      }).filter(function (format) {
        if (!format) return false;
        var dedupeKey = [format.support.toLowerCase(), format.first, format.second, format.unit].join(':');
        if (seen[dedupeKey]) return false;
        seen[dedupeKey] = true;
        return true;
      }).sort(function (a, b) {
        return (a.shortCm * a.longCm) - (b.shortCm * b.longCm);
      });

      sizeChoice.innerHTML = '';
      formats.forEach(function (format) {
        var option = document.createElement('option');
        option.value = format.key;
        option.textContent = optionLabel(format);
        option.disabled = !format.available;
        sizeChoice.appendChild(option);
      });

      var hasFormats = formats.length > 0;
      sizeControl.hidden = !hasFormats;
      emptyMessage.hidden = hasFormats;
      root.classList.toggle('alg-rv--empty', !hasFormats);
      if (!hasFormats) return;

      var selected = findFormatByProductValue(productSizeSelect && productSizeSelect.value)
        || findFormatByVariantId(data.selectedVariantId)
        || formats.find(function (format) { return format.available; })
        || formats[0];
      selectFormat(selected, false);
    }

    function activateOrientation(button, focusButton) {
      orientation = button.dataset.orientationChoice;
      orientationButtons.forEach(function (item) {
        var selected = item === button;
        item.setAttribute('aria-checked', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      if (focusButton) button.focus();
      updatePreview();
    }

    function activateRoom(button, focusButton) {
      var selectedRoom = button.dataset.roomChoice;
      roomButtons.forEach(function (item) {
        var selected = item === button;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      rooms.forEach(function (room) { room.hidden = room.dataset.room !== selectedRoom; });
      loadActiveRoomPhoto();
      if (focusButton) button.focus();
    }

    function keyboardNavigate(event, buttons, activate) {
      var keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
      if (keys.indexOf(event.key) === -1) return;
      event.preventDefault();
      var currentIndex = buttons.indexOf(event.currentTarget);
      var nextIndex = currentIndex;
      if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = buttons.length - 1;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
      else nextIndex = (currentIndex + 1) % buttons.length;
      activate(buttons[nextIndex], true);
    }

    orientationButtons.forEach(function (button) {
      button.addEventListener('click', function () { activateOrientation(button, false); });
      button.addEventListener('keydown', function (event) { keyboardNavigate(event, orientationButtons, activateOrientation); });
    });

    roomButtons.forEach(function (button) {
      button.addEventListener('click', function () { activateRoom(button, false); });
      button.addEventListener('keydown', function (event) { keyboardNavigate(event, roomButtons, activateRoom); });
    });

    sizeChoice.addEventListener('change', function () {
      var format = formats.find(function (item) { return item.key === sizeChoice.value; });
      selectFormat(format, true);
    });

    document.addEventListener('product:variant-change', function (event) {
      var variant = event.detail && event.detail.variant;
      var format = variant && findFormatByVariantId(variant.id);
      if (!format) return;
      syncingFromProduct = true;
      selectFormat(format, false);
      window.setTimeout(function () { syncingFromProduct = false; }, 0);
    });

    document.addEventListener('change', function (event) {
      if (event.target === productSizeSelect) {
        if (syncingFromProduct) return;
        var propertyFormat = findFormatByProductValue(productSizeSelect.value);
        if (propertyFormat) selectFormat(propertyFormat, false);
        return;
      }
      if (event.target === sizeChoice || !event.target.matches('select[name^="options"], input[name^="options"], [name="id"]')) return;
      window.setTimeout(function () {
        var variantIdInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (!variantIdInput) return;
        var format = findFormatByVariantId(variantIdInput.value);
        if (format) selectFormat(format, false);
      }, 0);
    });

    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(updatePreview).observe(stage);
    else window.addEventListener('resize', updatePreview);

    buildFormats();
    if (!productSizeSelect && typeof MutationObserver !== 'undefined') {
      var productSizeObserver = new MutationObserver(function () {
        var detectedSelect = findProductSizeSelect();
        if (!detectedSelect) return;
        productSizeObserver.disconnect();
        buildFormats();
      });
      productSizeObserver.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () { productSizeObserver.disconnect(); }, 60000);
    }
  }

  function initializeAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-alg-room-visualizer]')) initialize(context);
    if (!context.querySelectorAll) return;
    Array.prototype.forEach.call(context.querySelectorAll('[data-alg-room-visualizer]'), initialize);
  }

  if (window.AlgRoomVisualizer) {
    window.AlgRoomVisualizer.initializeAll(document);
    return;
  }

  window.AlgRoomVisualizer = { initializeAll: initializeAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); }, { once: true });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
